<section class="relative" [cdkMenuTriggerFor]="picker">
    <app-input
        [wrap]="wrap() ? 'true' : 'false'"
        [labelPosition]="labelPosition()"
        [color]="currentColor()"
        [size]="currentSize()"
        [rounded]="currentRounded()"
        [label]="label()"
        [required]="required()"
        [placeholder]="placeholder()"
        [spellcheck]="spellcheck()"
        [autocomplete]="autocomplete()"
        [autofocus]="autofocus()"
        [disabled]="disabled()"
        readonly
        [(value)]="value"
        [suffixIcon]="icon() || 'ic:baseline-access-alarm'"
        (inputClick)="handleOpenPicker()"
        (inputFocus)="handleOpenPicker()"
        (click)="validate($event)"
        type="time"
    />
</section>

<ng-template #picker>
    <app-time-picker
        cdkMenu
        [currentTime]="value()"
        class="absolute z-10 min-size-full w-max"
        (pick)="pick($event)"
    />
</ng-template>
